import gql from 'graphql-tag';

export const GET_APPLICANT_INFORMATION = gql`
  query ($id: ID!) {
    applicant(id: $id) {
      email
      name {
        givenName
        surname
        chineseName
      }
      gender
      dateOfBirth
      identity {
        identityType
        identityDocumentType
        identityDocumentNumber
      }
      nationality
      province
      addressLine1
      addressLine2
      addressLine3
      addressCountryRegion
      mobileNumber
      telephoneNumber
      disabilitySpecial {
        disabilitySpecialType
        disabilitySpecialDetail
      }
      _id
    }
  }
`;
